<template>
    <footer class="app__footer footer">
        <p class="app__footer__text">
            <a target="_blank" href="https://v-tax.be" title="V-tax web">V-tax</a> | Wiedauwkaai 98, 9000 Gent | <a href="mailto:pakjes@v-tax.be" title="mail ons">pakjes@v-tax.be</a> | BE0478770422 | <a target="_blank" href="https://www.privalex.be/nl/bedrijven/738f2697e3" title="privacy verklaring">Privacy</a> | <router-link to="/terms">Voorwaarden</router-link>
        </p>
    </footer>
</template>

<script>
    export default {
        name: "TheFooter"
    }
</script>